import { render, staticRenderFns } from "./serviços.vue?vue&type=template&id=0b7f691c&scoped=true&"
import script from "./serviços.vue?vue&type=script&lang=js&"
export * from "./serviços.vue?vue&type=script&lang=js&"
import style0 from "./serviços.vue?vue&type=style&index=0&id=0b7f691c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f691c",
  null
  
)

export default component.exports